import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { useReportsData } from '../../hooks/useReportsData';
import { ShieldAlert, Globe, ShoppingBag, Facebook, AlertOctagon } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/table';

export const BrandProtectionReport = () => {
    const [searchParams] = useSearchParams();
    const filters = { client: searchParams.get('client') };
    const { brandProtection, loading } = useReportsData(filters);

    return (
        <div className="space-y-6 animate-in fade-in duration-500">
            <div className="flex justify-between items-center">
                <h2 className="text-xl font-bold text-gray-900">Brand Protection</h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Impact Highlight */}
                <Card className="bg-gradient-to-br from-red-50 to-white border-red-100">
                    <CardHeader>
                        <CardTitle className="flex items-center gap-2 text-red-900">
                            <AlertOctagon className="h-5 w-5" />
                            Impacto Económico Estimado
                        </CardTitle>
                        <CardDescription>Valor de infracciones detectadas</CardDescription>
                    </CardHeader>
                    <CardContent>
                        <div className="text-4xl font-bold text-red-700">
                            ${brandProtection.reduce((acc, curr) => acc + curr.impact, 0).toLocaleString()} MXN
                        </div>
                    </CardContent>
                </Card>

                {/* Channels */}
                <Card>
                    <CardHeader><CardTitle>Infracciones por Canal</CardTitle></CardHeader>
                    <CardContent className="flex justify-around text-center">
                        <div>
                            <ShoppingBag className="h-8 w-8 mx-auto mb-2 text-orange-500" />
                            <div className="font-bold text-lg">Marketplaces</div>
                            <div className="text-sm text-gray-500">{brandProtection.filter(b => b.type === 'Marketplace').length} casos</div>
                        </div>
                        <div>
                            <Facebook className="h-8 w-8 mx-auto mb-2 text-blue-600" />
                            <div className="font-bold text-lg">Social</div>
                            <div className="text-sm text-gray-500">{brandProtection.filter(b => b.type === 'Social').length} casos</div>
                        </div>
                        <div>
                            <Globe className="h-8 w-8 mx-auto mb-2 text-gray-500" />
                            <div className="font-bold text-lg">Web</div>
                            <div className="text-sm text-gray-500">{brandProtection.filter(b => b.type === 'Listing').length} casos</div>
                        </div>
                    </CardContent>
                </Card>
            </div>

            <Card>
                <CardHeader><CardTitle>Casos Recientes</CardTitle></CardHeader>
                <CardContent>
                    <Table>
                        <TableHeader>
                            <TableRow>
                                <TableHead>ID Caso</TableHead>
                                <TableHead>Plataforma</TableHead>
                                <TableHead>Marca Afectada</TableHead>
                                <TableHead>Estatus</TableHead>
                                <TableHead>Impacto</TableHead>
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {brandProtection.map(item => (
                                <TableRow key={item.id}>
                                    <TableCell className="font-mono text-xs">{item.caseId}</TableCell>
                                    <TableCell>{item.platform}</TableCell>
                                    <TableCell>{item.trademark}</TableCell>
                                    <TableCell>
                                        <span className={`px-2 py-1 rounded-full text-xs font-semibold ${item.status === 'Abierto' ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'}`}>
                                            {item.status}
                                        </span>
                                    </TableCell>
                                    <TableCell>${item.impact.toLocaleString()}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </CardContent>
            </Card>
        </div>
    );
};
